import type { ComponentProps } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system/layout';
import { Heading, Text } from '@change-corgi/design-system/typography';

export function PageHeading(props: ComponentProps<typeof Box>) {
	return (
		<Box {...props}>
			<Heading size="h2" as="h2" mb={8} data-qa="comments-heading">
				<Translate value="fe.components.comments.reasons_for_signing" />
			</Heading>
			<Text data-qa="comments-intro">
				<Translate value="fe.components.comments.reasons_intro" />
			</Text>
		</Box>
	);
}
